import { CommonMessages } from 'appAssets/messages/common.messages';

export const PanelSettingsProductsMessages = {
    GetProductsFailed: {
        key: 'GetProductsFailed',
        message: 'Error while communication with the server. Cannot get available products.'
    },
    ...CommonMessages
};
